import type { Base_Bus } from './Base.Bus'
import type { Base_IComponentContext } from './Base.ui.Component'
import type { DS_TData } from '../DS/DS.Data'
import { Loca_addLocationToUser } from '../Loca/Loca.addLocationToUser'
import { Loca_getLocalAddress } from '../Loca/Loca.getLocalAddress'
import { Loca_ownersGet } from '../Loca/Loca.ownersGet'
import { Rout_toTimeline } from '../Rout/Rout.location'
import { Serv_send } from '../Serv/Serv.socketClient'
import { Sync_sync } from '../Sync/Sync.initialise'
import SmartDataStore from '../../src/stores/smartdata'
import { Base_commonDeps } from './Base.commonDeps'

// Bake in the data and operations type from the one used
// in the base component.
export interface Base_IContext extends Base_IComponentContext<DS_TData, Base_IOperations> {}

export interface Base_IOperations {
    now: () => Date
    getBus: () => Base_Bus
    Serv_send: typeof Serv_send
    Sync_sync: typeof Sync_sync
    Rout_toTimeline: typeof Rout_toTimeline
    Loca_ownersGet: typeof Loca_ownersGet
    Loca_addLocationToUser: typeof Loca_addLocationToUser
    Loca_getLocalAddress: typeof Loca_getLocalAddress
    SmartDataStore_getStatus: typeof SmartDataStore.getStatus
    SmartDataStore_getData: typeof SmartDataStore.getData
    SmartDataStore_getOrdering: typeof SmartDataStore.getOrdering
    Base_commonDeps: typeof Base_commonDeps
}

export function Base_defaultOperations(bus: Base_Bus): Base_IOperations {
    return {
        now: () => new Date(),
        getBus: () => bus,
        Serv_send,
        Sync_sync,
        Rout_toTimeline,
        Loca_ownersGet,
        Loca_addLocationToUser,
        Loca_getLocalAddress,
        SmartDataStore_getStatus: SmartDataStore.getStatus,
        SmartDataStore_getData: SmartDataStore.getData,
        SmartDataStore_getOrdering: SmartDataStore.getOrdering,
        Base_commonDeps,
    }
}
